// extracted by mini-css-extract-plugin
export var AsideProminentButton = "templates-module--AsideProminentButton--1db9e";
export var NoPointerDesktop = "templates-module--NoPointerDesktop--ca05f";
export var ProminentButton = "templates-module--ProminentButton--1a891";
export var slideIn = "templates-module--slide-in--13211";
export var slideInFromRight = "templates-module--slide-in-from-right--25769";